import React, { useContext } from "react";
import { HotelContext } from "../../context/HotelContext";
import { translate } from "../../utils/Translation";
import { LoadingIndicator } from "../../components/v2/cards";

const RewardsBenefitsTable = ({
  loading,
  analysisRows,
  getRewardLogoSrc,
  getRewardIconColor,
  formatCompactNumber,
}) => {
  const { lang } = useContext(HotelContext);

  return (
    <div className="rewards-list__card rewards-list__card-large rewards-list__benefits-card">
      <div className="rewards-list__card-header">
        <h3 className="rewards-list__card-title">{translate("v2_rewards_benefits_title", lang)}</h3>
        <p className="rewards-list__card-subtitle">{translate("v2_rewards_benefits_sub", lang)}</p>
      </div>

      <div className="rewards-list__table rewards-list__benefits">
        <div className="rewards-list__table-header">
          <div className="rewards-list__th rewards-list__th--name">{translate("v2_rewards_analysis_name", lang)}</div>
          <div className="rewards-list__th rewards-list__th--upsales">{translate("v2_rewards_benefits_upsales", lang)}</div>
          <div className="rewards-list__th rewards-list__th--reductions">{translate("v2_rewards_benefits_claim_count", lang)}</div>
          <div className="rewards-list__th rewards-list__th--gain">{translate("v2_rewards_benefits_total_gain", lang)}</div>
        </div>

        <div className="rewards-list__table-body">
          {loading ? (
            <div className="rewards-list__table-loading">
              <LoadingIndicator />
            </div>
          ) : analysisRows.filter((row) => (row.rwAmount ?? 0) > 0).length === 0 ? (
            <div className="rewards-list__table-empty">{translate("v2_no_data", lang)}</div>
          ) : (
            analysisRows
              .filter((row) => (row.rwAmount ?? 0) > 0)
              .slice(0, 6)
              .map((row, idx, filteredRows) => (
                <React.Fragment key={`benefit-${row.rwId}`}>
                  <div className="rewards-list__tr rewards-list__tr--benefit">
                    <div className="rewards-list__td rewards-list__td--name">
                      {getRewardLogoSrc(row.rwType) ? (
                        <img className="rewards-list__reward-logo" src={getRewardLogoSrc(row.rwType)} alt="" aria-hidden="true" />
                      ) : (
                        <span
                          className="rewards-list__reward-icon"
                          style={{ backgroundColor: getRewardIconColor(row.name, row.rwType) }}
                          aria-hidden="true"
                        />
                      )}
                      <span className="rewards-list__reward-name">{row.name}</span>
                    </div>
                    <div className="rewards-list__td rewards-list__td--upsales">
                      {formatCompactNumber(row.rwAmount ?? 0)} <span className="rewards-list__muted">€</span>
                    </div>
                    <div className="rewards-list__td rewards-list__td--reductions">
                      {formatCompactNumber(row.usedCount || 0)}{" "}
                    </div>
                    <div className="rewards-list__td rewards-list__td--gain">
                      {formatCompactNumber(row.totalGain ?? (row.usedCount || 0) * (row.rwAmount || 0))}{" "}
                      <span className="rewards-list__muted">€</span>
                    </div>
                  </div>
                  {idx < Math.min(filteredRows.length, 6) - 1 && <div className="rewards-list__separator" />}
                </React.Fragment>
              ))
          )}
        </div>
      </div>
    </div>
  );
};

export default RewardsBenefitsTable;
